import { render, staticRenderFns } from "./DbPageTwoColumn.vue?vue&type=template&id=560447e4&scoped=true&"
import script from "./DbPageTwoColumn.vue?vue&type=script&lang=ts&"
export * from "./DbPageTwoColumn.vue?vue&type=script&lang=ts&"
import style0 from "./DbPageTwoColumn.vue?vue&type=style&index=0&id=560447e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560447e4",
  null
  
)

export default component.exports